import { BinaryWriter } from '../BinaryWriter';
export const createSerializeWire = (serializeWireBase) => () => {
    const writer = new BinaryWriter();
    serializeWireBase(writer);
    return writer.toBuffer();
};

//# sourceMappingURL=Serializable.js.map
